import React, { createContext, useState, useMemo, useContext, useEffect, ReactNode } from "react";
import { ScreenSizeContextType, TamanoPantalla } from "types";

const ScreenSizeContext = createContext<ScreenSizeContextType | null>(null);

interface ScreenSizeProviderProps {
  children: ReactNode;
}

export const ScreenSizeProvider: React.FC<ScreenSizeProviderProps> = ({ children }) => {
  const [tamanoPantalla, setTamanoPantalla] = useState<TamanoPantalla | undefined>({
    ancho: undefined,
    alto: undefined,
  });
  const [isMobile, setIsMobile] = useState<boolean>(false);

  /**
   * Cuando la pantalla cambie de tamaño, detectamos de que tipo de pantalla
   * se trata para saber si mostrar el Layout mobile o web
   */
  useEffect(() => {
    if (tamanoPantalla && tamanoPantalla.ancho) {
      setIsMobile(tamanoPantalla.ancho <= 768);
    }
  }, [tamanoPantalla]);
  /**
   * Para prevenir que se muestre el titulo incorrecto, cuando se termina la
   * carga, se elimina cualquier titulo previo
   */
  useEffect(() => {
    if (!isMobile && tamanoPantalla) {
      setTamanoPantalla(undefined);
    }
  }, [isMobile, tamanoPantalla]);

  const state = useMemo<ScreenSizeContextType>(
    () => ({
      isMobile,
      setTamanoPantalla,
    }),
    [isMobile]
  );

  return (
    <ScreenSizeContext.Provider value={state}>
      {children}
    </ScreenSizeContext.Provider>
  );
};

export const useTamanoPantalla = (): ScreenSizeContextType => {
  const context = useContext(ScreenSizeContext);

  if (!context) {
    throw new Error("useTamanoPantalla must be used within a ScreenSizeProvider");
  }

  return context;
};
